import React from 'react'

import type { ReactNode } from 'react'

import type { Money } from '@s4l/stayforlong/kernel/Money'
import PriceDiff from '../PriceDiff'
import { Form } from '@s4l/ds'
import type { UtilityClassNames } from '@s4l/utility-css'
import RadioItemPlaceholder from './Placeholder'

import styles from './styles.module.css'

interface RadioItemProps {
  label: ReactNode
  value: string
  diff: { total: Money; perNight: Money } | null
  name: string
}

function RadioItem({ label, value, diff, name }: Readonly<RadioItemProps>) {
  return (
    <div className={styles.container}>
      <Form.Label className={styles.label as UtilityClassNames}>
        <Form.RadioButton name={name} value={value} disabled={!diff} />
        <div className={styles.labelContent}>
          <div className={styles.labelText}>{label}</div>
          <div className={styles.labelRight}>
            <PriceDiff diff={diff} />
          </div>
        </div>
      </Form.Label>
    </div>
  )
}

RadioItem.displayName = 'RadioItem'
RadioItem.Placeholder = RadioItemPlaceholder

export default RadioItem
